import { Component, HostBinding, Input } from '@angular/core';

import { GLinkNavigationItem } from 'app/core/types';

@Component({
    selector   : 'glink-nav-vertical-group',
    templateUrl: './group.component.html',
    styleUrls  : ['./group.component.scss']
})
export class GLinkNavVerticalGroupComponent
{
    @HostBinding('class')
    classes = 'nav-group nav-item';

    @Input()
    item: GLinkNavigationItem;

    /**
     * Constructor
     */
    constructor()
    {
    }

}
